import React, { useCallback, useState } from 'react';
import { BiData } from '@wix/da-bi/pkg/events';
import { getDeviationResourceType, getDeviationType } from '../../../DeviationViews/_helpers';
import { DeviationTypes } from '../../../types/deviation';
import DeleteConfirmationModal from './DeleteConfirmationModal';
import { useDeleteDeviationAction } from './useDeleteDeviationAction';
import TierCreatorReduxModule from '../../../Tier/redux/creator/ModuleLoadable';
/**
 * Provides a callback for enacting our deviation deletion flow. Includes an accompanying confirmation modal for
 * deviation types that require it.
 */ export function useDeleteDeviationFlow(deviation, { redirectTo, supportTierDeletion }) {
    const dispatchDeleteDeviationAction = useDeleteDeviationAction();
    const [isShowingConfirmation, setShowingConfirmation] = useState(false);
    const enactFlow = useCallback(()=>{
        const type = getDeviationType(deviation);
        if (type === DeviationTypes.TIER) {
            dispatchDeleteDeviationAction({
                deviation,
                redirectTo
            });
        } else {
            setShowingConfirmation(true);
        }
    }, [
        dispatchDeleteDeviationAction,
        deviation,
        redirectTo
    ]);
    const handleConfirm = useCallback(()=>{
        setShowingConfirmation(false);
        dispatchDeleteDeviationAction({
            deviation,
            shouldRedirect: true,
            redirectTo
        });
    }, [
        dispatchDeleteDeviationAction,
        deviation,
        redirectTo
    ]);
    const handleCancel = useCallback(()=>{
        setShowingConfirmation(false);
    }, []);
    return {
        /**
     * Depending on deviation type, this callback will either dispatch a delete action or show a confirmation modal.
     */ enactFlow,
        /**
     * biData you'd add to the button that beings the delete flow.
     */ biData: BiData({
            evid: 372,
            typeid: getDeviationResourceType(deviation),
            itemid: deviation.deviationId
        }),
        /**
     * The necessary supporting components. e.g modals, redux modules
     *
     * If you don't render this in your component, this hook won't work.
     */ supportingComponents: /*#__PURE__*/ React.createElement(React.Fragment, null, supportTierDeletion && /*#__PURE__*/ React.createElement(TierCreatorReduxModule, null), /*#__PURE__*/ React.createElement(DeleteConfirmationModal, {
            key: "delete-confirmation-modal",
            deviation: deviation,
            isOpen: isShowingConfirmation,
            onConfirm: handleConfirm,
            onCancel: handleCancel
        }))
    };
}

//# sourceMappingURL=useDeleteDeviationFlow.js.map